import gql from 'graphql-tag';

export const createCommercialFacilityNote = gql`
  mutation createCommercialFacilityNote($input: CommercialFacilityNoteInput!) {
    createCommercialFacilityNote(input: $input) {
      id
      commercialFacilityId
      note
      createdAt
      createdBy
      updatedAt
      updater
      deletedAt
      version
    }
  }
`;
